import { fromSpecific } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import { ValuableNode } from '../../models/ValuableNode'

export class SchemaMapNode extends ValuableNode {
  @fromSpecific()
  @reactive('deep')
  entries?: [any, any][]
}

declare global {
  export interface RehajeTypedNodes {
    'Schema.Map': SchemaMapNode
  }
}
